// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PRODUCT_LOADING() {
      return {
        isLoading: true
      };
    },
    PRODUCT_LOADED() {
      return {
        isLoading: false,
        data: action.product
      };
    },
    PRODUCT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.product.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
